class ShareEmail {
    constructor(passedElement) {}

    init() {
        let self = this;
        document.addEventListener("DOMContentLoaded", () => {
            const recaptcha = document.querySelector(".g-recaptcha");
            recaptcha.setAttribute("data-theme", "dark");

            const form = document.getElementById("contactForm");
            const formMessage = document.getElementById("formMessage");
            const submitBtn = document.getElementById("submitBtn");

            // Enable the submit button after reCAPTCHA verification
            function enableSubmitButton() {
                submitBtn.disabled = false;
            }

            // Form submission handling
            form.addEventListener("submit", function (event) {
                event.preventDefault();

                const recaptchaResponse = grecaptcha.getResponse();

                if (recaptchaResponse.length === 0) {
                    // Show warning message if reCAPTCHA is not completed
                    formMessage.innerText = "Please complete the reCAPTCHA verification.";
                    formMessage.style.color = "red";
                } else {
                    const formData = new FormData(form);

                    // Disable the submit button while submitting
                    submitBtn.disabled = true;

                    fetch(form.action, {
                        method: "POST",
                        body: formData,
                        headers: {
                            "X-CSRF-Token": formData.get("{{ csrfInput() }}"), // Include CSRF token
                        },
                    })
                        .then((response) => response.json())
                        .then((data) => {
                            if (data.success) {
                                formMessage.innerHTML = '<div class="[ alert alert-success ] [ mt-3 ]">Shared successfully.</div>';
                                setTimeout(() => {
                                    location.reload(); // Refresh page after 2 seconds
                                }, 2000);
                            } else {
                                showError();
                            }
                        })
                        .catch(showError);
                }
            });

            // Helper function for showing error message
            function showError() {
                formMessage.innerHTML = '<div class="[ alert alert-danger ] [ mt-3 ]">Oops! Something went wrong. Please try again later.</div>';
                setTimeout(() => {
                    location.reload(); // Refresh page after 2 seconds
                }, 2000);
            }
        });
    }
}
export default ShareEmail;
